import * as React from "react";
import PropTypes from "prop-types";

import Typography from "ui/Typography";
import IconButtonCross from "components/buttons/IconButtonCross";

const Header = ({ onClose }) => {
  return (
    <div className="theme-builder-r-header">
      <Typography variant="h5">Theme preview</Typography>
      <IconButtonCross onClick={onClose} />
    </div>
  );
};

Header.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default Header;
